import { render, staticRenderFns } from "./DollarSignIcon.vue?vue&type=template&id=0f0b6182"
import script from "./DollarSignIcon.vue?vue&type=script&lang=js"
export * from "./DollarSignIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports